import { forwardRef, useImperativeHandle } from 'react';

import { RootState } from 'src/store/store';
import { TabsContent } from '../../AddContact';
import TextArea from '../../../../UI/forms/TextArea';
import { useDispatch, useSelector } from 'react-redux';
import { createContactForm } from 'src/store/blackbook/createContactSlice';

const Notes = forwardRef((_props, ref: TabsContent['ref']) => {
  const dispatch = useDispatch();
  const data = useSelector((state: RootState) => state.createContactFormSlice.data);

  useImperativeHandle(ref, () => ({
    async handleValidation() {
      return true
    }
  }));

  return (
    <div className="container-fluid px-3 mt-3">
      <TextArea
        title="General note"
        value={`${data.note ? data.note : ''}`}
        placeHolder="Type here..."
        /* @ts-ignore */
        onChange={(val) => dispatch(createContactForm.setField('note', val, false))}
      />
      <TextArea
        placeHolder="Type here..."
        title="Dietary and health note"
        value={`${data?.data?.health_note || ''}`}
        /* @ts-ignore */
        onChange={(val) => dispatch(createContactForm.setField('health_note', val))}
      />
    </div>
  );
});

export default Notes;
